// removed by extract-text-webpack-plugin
module.exports = {"spinner":"spinner__spinner___3II-1","rotation":"spinner__rotation___1n7pu"};


/*****************
 ** WEBPACK FOOTER
 ** ./src/components/spinner/spinner.scss
 ** module id = 1306
 ** module chunks = 1
 **/